import { useAPI, useStrapiApi } from "~/uses/useMyFetch.js";
import {
  getCategorySliderQuery,
  getSelectionsQuery,
} from "~/utils/strapiQuery.utils.js";
import { getPostsQuery } from "~/nuxt_modules/blog/utils/query.utils.js";
import { Product } from "~/models/product.model.js";
import { fetchReviews } from "~/utils/API.js";
import { useProductStore } from "~/store/productStore.js";
import { useCriteriaStore } from "~/store/criteriaStore.js";
import { useCategoriesStore } from "~/store/categoriesStore.js";

export const fetchProductCatalogData = async (category, route) => {
  const productStore = useProductStore();
  const criteriaStore = useCriteriaStore();
  const categoryStore = useCategoriesStore();

  const [
    selections,
    categorySlider,
    relatedPosts,
    productsWithVideo,
    productsWithReview,
  ] = await Promise.all([
    new Promise((resolve) => {
      if (undefined === category || 0 === route.params.specifications.length) {
        return resolve({ data: null });
      }

      return resolve(
        useStrapiApi(
          `/specification/selections?${getSelectionsQuery(category.code)}`,
        ).catch(() => ({ data: null })),
      );
    }),
    useStrapiApi(`/sliders/categories?${getCategorySliderQuery()}`).catch(
      () => ({ data: [] }),
    ),
    new Promise((resolve) => {
      if (undefined === category) {
        return resolve({ data: [] });
      }

      return resolve(
        useStrapiApi(
          `/blog/posts?${getPostsQuery(
            { page: 1, pageSize: 4 },
            {
              tags: {
                relatedCategories: {
                  category: {
                    code: {
                      $in: category.code,
                    },
                  },
                },
              },
            },
          )}`,
        ).catch(() => ({ data: [] })),
      );
    }),
    new Promise((resolve) => {
      if (undefined === category) {
        return resolve([]);
      }

      return resolve(
        useAPI("/catalog/product/list/attachment", {
          params: {
            attachmentGroup: Product.ATTACHMENT_GROUP.VIDEO,
            categoryId: category.id,
            limit: 3,
            "fields[]": ["attachments"],
          },
        }).then((dtoProducts) =>
          dtoProducts.map((dtoProduct) => new Product(dtoProduct)),
        ),
      );
    }),
    new Promise((resolve) => {
      if (undefined === category) {
        return resolve({ data: [] });
      }

      return resolve(
        fetchReviews(
          { categoryCode: category.code, withProduct: true },
          { page: 1, pageSize: 3 },
          ["reply", "cons", "pros"],
        ).catch(() => ({ data: [] })),
      );
    }),

    new Promise((resolve) => resolve(productStore.fetch())),
    new Promise((resolve) => resolve(criteriaStore.fetch())),
    new Promise((resolve) =>
      undefined !== category
        ? resolve(categoryStore.fetchContent(category.id))
        : resolve(),
    ),
  ]);

  return {
    selections: selections.data,
    categorySlider: categorySlider.data,
    relatedPosts: relatedPosts.data,
    productsWithVideo,
    productsWithReview: productsWithReview.data,
  };
};
